// ─────────────────────────────────────────────────────────────────────────────
// i18n/locales/it.ts – Italiano
// ─────────────────────────────────────────────────────────────────────────────
export default {
  lang: { de: 'Deutsch', fr: 'Français', it: 'Italiano', en: 'English', es: 'Español', pt: 'Português' },

  nav: {
    // Menuepunkt der Uebersichtsseite (T-M41.3) — eigener Schluessel neben
    // `nav.dashboard`, das zwei andere Stellen beschriftet.
    overview:     'Panoramica',
    dashboard:    'Dashboard',
    jobs:         'Lavori di stampa',
    fleet:        'Flotta',
    printers:     'Stampanti',
    schankanlage: 'Impianto di spillatura',
    printserver:  'Server di stampa',
    settings:     'Impostazioni',
    users:        'Utenti',
    company:      'Azienda',
    locations:    'Sedi',
    smtp:         'E-mail SMTP',
    api:          'API',
    switchCompany:'Cambia azienda',
    selectCompany:'Seleziona azienda',
    logout:       'Disconnetti',
  },

  common: {
    save:          'Salva',
    saving:        'Salvataggio in corso …',
    cancel:        'Annulla',
    delete:        'Elimina',
    deleting:      'Eliminazione in corso …',
    edit:          'Modifica',
    add:           'Aggiungi',
    back:          'Indietro',
    loading:       'Caricamento in corso …',
    search:        'Cerca …',
    yes:           'Sì',
    no:            'No',
    confirm:       'Conferma',
    confirmDelete: 'Eliminare davvero?',
    cannotUndo:    'Questa azione non può essere annullata.',
    new:           'Nuovo',
    optional:      '(opzionale)',
    unknown:       '—',
    active:        'Attivo',
    inactive:      'Inattivo',
    enabled:       'Abilitato',
    disabled:      'Disabilitato',
    seconds:       'sec.',
    minutes:       'min.',
    noData:        'Nessun dato disponibile.',
    close:         'Chiudi',
    remove:        'Rimuovi',
    copy:          'Copia',
    copied:        'Copiato!',
    change:        'Modifica',
    send:          'Invia',
    sending:       'Invio in corso …',
    processing:    'Elaborazione in corso …',
    show:          'Mostra',
    hide:          'Nascondi',
    yesDelete:     'Sì, elimina',
    yesRemove:     'Sì, rimuovi',
    note:          'Nota',
    error:         'Errore',
    version:       'Versione',
    // Kennzahl, die NICHT serverseitig gezaehlt ist: Untergrenze (REQ-OPS-034)
    count: {
      atLeast:      'Almeno {count}',
      atLeastShort: '≥ {count}',
      atLeastHint:  'Ricavato dall\'elenco caricato – almeno questi, forse di più.',
    },
    // Blaettern statt Kuerzen (REQ-OPS-032/033, T-M8.19b) — die zwei Texte,
    // die in JEDER geblaetterten Liste gleich lauten.
    pagination: {
      liveFirstPageOnly: 'Solo la prima pagina viene aggiornata in tempo reale.',
      loadFailed:        'Caricamento non riuscito.',
    },
  },

  status: {
    online:   'Online',
    offline:  'Offline',
    printing: 'Stampa in corso',
    error:    'Errore',
    ready:    'Pronto',
    pending:  'In attesa',
    done:     'Completato',
    // Stato di consegna `completed` (REQ-DM-040) — vedi de.ts.
    completed: 'Consegnato',
    failed:   'Fallito',
    expired:  'Scaduto',
  },

  role: {
    admin:    'Amministratore',
    user:     'Utente',
  },

  auth: {
    email:               'Indirizzo e-mail',
    password:            'Password',
    passwordNew:         'Nuova password',
    passwordNewLabel:    'Nuova password *',
    passwordConfirm:     'Conferma password',
    passwordConfirmLabel:'Conferma password *',
    passwordMinHint:     'Almeno 8 caratteri',
    passwordRepeat:      'Ripeti password',
    passwordMismatch:    'Le password non corrispondono.',
    passwordTooWeak:     'La password è troppo debole (almeno 8 caratteri).',
    passwordSave:        'Salva password',
    passwordSaved:       'Password salvata!',
    passwordSavedHint:   'La tua password è stata modificata con successo. Verrai reindirizzato automaticamente …',
    toDashboard:         'Vai alla dashboard',
    linkInvalid:         'Link non valido',
    linkInvalidHint:     'Questo link è scaduto o è già stato utilizzato. Richiedine uno nuovo.',
    toLogin:             'Vai al login',
    setNewPassword:      'Imposta nuova password',
    setNewPasswordHint:  'Inserisci la tua nuova password per',
    welcomeBack:         'Bentornato',
    welcomeHint:         'Accedi con il tuo account.',
    login:               'Accedi',
    loggingIn:           'Accesso in corso …',
    logout:              'Disconnetti',
    forgotPassword:      'Password dimenticata?',
    resetPassword:       'Reimposta password',
    resetSent:           'E-mail inviata. Controlla la tua casella di posta.',
    backToLogin:         'Torna al login',
    sessionExpired:      'La sessione è scaduta (12 ore). Effettua nuovamente il login.',
    footer:              'Payfix AG · Sistema di gestione della stampa · v1.0',
    strength: {
      weak:      'Debole',
      medium:    'Media',
      strong:    'Forte',
      veryStrong:'Molto forte',
    },
    errors: {
      invalidEmail:    'Indirizzo e-mail non valido.',
      wrongPassword:   'Password errata.',
      userNotFound:    'Nessun utente trovato con questa e-mail.',
      tooManyRequests: 'Troppi tentativi. Attendere prego.',
      generic:         'Accesso fallito. Riprova.',
      occurred:        'Si è verificato un errore.',
    },
  },

  invitation: {
    title:        'Accettare l\'invito',
    subtitle:     'Imposta la tua password per creare il tuo account.',
    submit:       'Crea account',
    working:      'Creazione dell\'account …',
    successTitle: 'Il tuo account è pronto',
    successHint:  'Verrai connesso e reindirizzato …',
    errInvalid:   'Questo invito non è valido. Richiedi un nuovo invito.',
    errExpired:   'Questo invito è scaduto. Richiedi un nuovo invito.',
    errExists:    'Per questo indirizzo esiste già un account. Accedi con la tua password attuale.',
    errFailed:    'Non è stato possibile accettare l\'invito. Non è stato creato nulla; riprova.',
  },

  bootstrap: {
    errorTitle: 'Avvio non riuscito',
    errorHint:  'Non è stato possibile completare l\'accesso. Riprova o effettua di nuovo l\'accesso.',
    errorHintNoProfile: 'Per questo account non esiste alcun profilo utente. Contatta il tuo amministratore.',
    errorCode:  'Codice di errore: {code}',
    retry:      'Riprova',
    reLogin:    'Accedi di nuovo',
  },

  // T-M21.5 / REQ-OPS-054: l'avviso INDICA le aree interessate e non mostra
  // ALCUN orario — l'ora dell'ultimo aggiornamento ricevuto non è registrata.
  liveVerbindung: {
    title:     'Aggiornamento in tempo reale interrotto',
    areas:     'Non più in tempo reale: {areas}',
    hint:      'I dati visualizzati provengono dall\'ultimo aggiornamento ricevuto e possono essere obsoleti. Verranno aggiornati di nuovo solo quando la connessione sarà ristabilita.',
    reconnect: 'Riconnetti',
    quiet:     'Connessione interrotta: {areas}',
    area: {
      jobs:         'Lavori di stampa',
      printers:     'Stampanti',
      printservers: 'Server di stampa',
      companies:    'Aziende',
      locations:    'Sedi',
      registers:    'Casse',
      users:        'Utenti',
      apiTokens:    'Token API',
    },
  },

  fleet: {
    title:          'Flotta',
    subtitle:       'Server di stampa per sede – stato, versione e code in tempo reale.',
    empty:          'Nessun server di stampa',
    emptyHint:      'Appena un server di stampa è configurato, compare qui.',
    noLocation:     'Senza sede',
    noServers:      'Nessun server di stampa in questa sede',
    noPrinters:     'Nessuna stampante',
    unassignedPrinters: {
      text:   'Una stampante attende l\'assegnazione | {count} stampanti attendono l\'assegnazione',
      hint:   'Queste stampanti sono state create tramite l\'interfaccia e non hanno un server di stampa assegnato. Non compaiono in nessun gruppo di questa vista e accetteranno lavori solo dopo l\'assegnazione di un server di stampa.',
      action: 'Assegna nell\'elenco delle stampanti',
    },
    locationOffline:'Sede offline',
    serverCount:    '{n} server di stampa',
    version:        'Versione',
    versionUnknown: 'Sconosciuta',
    versionOutlier: 'Difforme',
    versionOutlierHint: 'Diverge dalla versione della flotta v{version}.',
    lastPing:       'Ultimo segnale di vita',
    pending:        '{n} in attesa',
    queueEmpty:     'Nessun lavoro in attesa',
    pendingAtLeast: 'Almeno {n} in attesa',
    queueUnknown:   'Coda sconosciuta',
    queueUnknownHint: 'Non è stato possibile contare la coda. Questo non significa che sia vuota.',
    queueHeldHeading: 'Trattenuti ({n})',
    queueHeldHint:    'Questi lavori vengono stampati solo quando la cucina li imposta su «Pronto per il ritiro». Per questo non hanno una posizione in coda.',
    queueNoneWaiting: 'Nulla è in attesa della stampante',
    time: {
      never:        'Mai',
      justNow:      'Proprio ora',
      minutes:      '{n} min fa',
      hours:        '{n} h fa',
      days:         '{n} giorni fa',
    },
  },

  dashboard: {
    title:          'Dashboard',
    welcome:        'Benvenuto',
    totalJobs:      'Lavori totali',
    totalPrinters:  'Stampanti totali',
    onlinePrinters: 'Stampanti online',
    printservers:   'Server di stampa',
    recentJobs:     'Ultimi lavori di stampa',
    noJobs:         'Nessun lavoro di stampa disponibile.',
    heldJobs:       'Trattenuti',
    heldJobsHint:   'Queste comande vengono stampate solo quando la cucina le imposta su «Pronto per il ritiro». Non sono in attesa della stampante e non sono un ingorgo.',
  },

  printers: {
    title:         'Stampanti',
    subtitle:      'Tutte le stampanti collegate di questa azienda',
    add:           'Aggiungi stampante',
    empty:         'Nessuna stampante creata',
    emptyHint:     'Aggiungi la prima stampante di questa azienda.',
    number:        'N.',
    name:          'Denominazione',
    type:          'Tipo',
    printserver:   'Server di stampa',
    ipAddress:     'Indirizzo IP',
    pendingBons:   'Scontrini in attesa',
    deleteTitle:   'Eliminare la stampante?',
    deleteConfirm: 'Vuoi davvero eliminare {name}?',
    new:           'Nuova stampante',
    edit:          'Modifica',
    openKitchen:      'Apri Kitchen TV',
    openAbholscreen:  'Apri schermo di ritiro',
    openFastline:     'Apri Fastline',
    // BERICHTIGT AM 2026-08-17 (T-M8.19b, REQ-OPS-032 neu gefasst): der
    // Schluessel bleibt, sein Wortlaut wird berichtigt statt geloescht. Bis
    // dahin sagte er „die Liste ist gekuerzt, weitere Drucker sind hier nicht
    // sichtbar" — eine Sackgasse. Die 100 sind ab jetzt die SEITENgroesse.
    limitReached:     'Esistono altre stampanti di questa azienda: viene caricata una pagina di {count} voci — carica altre.',
    loadMore:         'Carica altre {count} stampanti',
    // Kurzform fuer das Nachladen IM Auswahlkontext (Drucker-Dropdown der
    // Auftragsliste): dort ist kein Platz fuer die Seitengroesse.
    loadMoreShort:    'Carica altre stampanti …',
    loadedCount:      '{count} stampanti caricate',
    endOfList:        'Fine dell\'elenco – tutte le stampanti sono caricate.',
    sections: {
      basic:       'Dati di base',
      abholscreen: 'Impostazioni schermata di ritiro',
      kitchenTv:   'Impostazioni Kitchen TV',
      alarm:       'Avvisi',
      status:      'Stato',
      screenAccess: 'Chiave di visualizzazione',
    },
    fields: {
      outputType:        'Tipo di uscita',
      outputPrint:       'Stampante',
      outputKitchenTv:   'Kitchen TV / Schermo',
      outputPrintHint:   'Stampante ESC/POS fisica con indirizzo e tipo di modello.',
      outputKitchenTvHint: 'Canale schermo senza server di stampa, indirizzo o tipo di modello.',
      port:              'Porta',
      abholscreenEnabled: 'Schermata di ritiro attiva',
      abholscreenEnabledHint: 'Mostra i numeri degli ordini pronti sulla schermata di ritiro.',
      displayDurationHint: 'Durata di visualizzazione degli ordini pronti, da 5 a 600 secondi (predefinito 60 secondi).',
      autoCompleteDisabled:     'Disattiva il completamento automatico',
      autoCompleteDisabledHint: 'Gli ordini pronti restano visibili finché non vengono chiusi a mano — la durata di visualizzazione non li chiude più. Quattro ore dopo l\'arrivo vengono comunque chiusi automaticamente; questa pulizia non si può disattivare.',
      maxItems:          'Numeri mostrati max.',
      maxItemsUnit:      'numeri',
      maxItemsHint:      'Limite dei numeri mostrati contemporaneamente (0 = illimitato).',
      screenKeyHint:       'La chiave di visualizzazione registra uno schermo (Kitchen TV, schermo di ritiro, Fastline). Viene salvato solo l’hash; il testo in chiaro non è più recuperabile.',
      screenKeySaveFirst:  'Salva prima il canale, poi potrai impostare una chiave di visualizzazione.',
      screenKeySet:        'Chiave di visualizzazione impostata',
      screenKeyNotSet:     'Nessuna chiave di visualizzazione',
      screenKeyPlaceholder:'Inserisci o genera una chiave',
      screenKeyGenerate:   'Genera',
      screenKeySave:       'Imposta chiave',
      screenKeyRotate:     'Ruota chiave',
      screenKeyOnce:       'Questa chiave viene mostrata solo UNA volta. Annotala ora in modo sicuro.',
      screenKeyRequired:        'Richiedi la chiave di visualizzazione',
      screenKeyRequiredHint:    'Uno schermo accede a questo canale con la chiave di visualizzazione. Senza di essa non ottiene alcun accesso.',
      screenKeyRequiredOffHint: 'Questo canale è aperto senza chiave di visualizzazione: chi conosce l’indirizzo dello schermo legge gli ordini di questo canale e ne imposta lo stato di lavorazione. L’accesso resta limitato a questo canale e a questa azienda.',
      screenKeyRequiredOffPrintHint: 'Su questo canale ciò avvia anche una stampa: chi imposta un ordine su «Pronto per il ritiro» libera la comanda trattenuta, che viene stampata.',
      alarmEnabled:      'Avvisi attivi',
      alarmEnabledHint:  'Notifica in caso di problemi della stampante (offline, errore).',
      alarmMuted:        'Silenzia completamente',
      alarmMutedHint:    'Sopprime tutti gli avvisi di questa stampante.',
      alarmStages:       'Livelli di avviso',
      stage_offline:     'Offline',
      stage_paperLow:    'Carta quasi esaurita',
      stage_error:       'Errore',
      stage_coverOpen:   'Coperchio aperto',
      // Stufe Papierende (T-M42.3, REQ-PS-023c) und Kennzeichnung unwirksamer
      // Stufen je Modelltyp (REQ-PS-023a Praez. 1 (a) / Praez. 3).
      stage_paperOut:    'Carta esaurita',
      stageIneffective:  'senza effetto',
      stageIneffectiveTitle: 'Il tipo di modello {model} non segnala questo stato. Il livello può essere attivato, ma su questa stampante non genera mai un avviso.',
      stagesIneffectiveHint: 'I livelli contrassegnati «senza effetto» non vengono segnalati dal tipo di modello {model}: possono essere attivati, ma su questa stampante non generano mai un avviso.',
      // T-M42.10 Teil (b): die gesetzten Stufen wuerden mangels Einrichtung
      // am Mandanten nie versendet (Regel: utils/alarmEinrichtung.ts).
      alarmNotSetUpTypeDisabled: 'Allarmi non configurati: nel centro allarmi dell\'azienda «Guasto stampante» è disattivato. I livelli impostati qui non vengono mai inviati.',
      alarmNotSetUpNoRecipients: 'Allarmi non configurati: nel centro allarmi dell\'azienda non è indicato alcun destinatario. I livelli impostati qui non vengono mai inviati.',
      printerId:         'ID stampante',
      printerIdPlaceholder: 'p. es. 3324',
      printerIdHint:     'L\'ID stampante dal portale Payfix — esattamente il valore che la cassa invia come printer_id. Non un numero scelto liberamente: senza l\'ID corretto nessuno scontrino raggiunge questo canale.',
      designation:       'Denominazione',
      printerType:       'Tipo di stampante',
      printerServer:     'Server di stampa',
      ipAddress:         'Indirizzo IP',
      sameAddressHint:   'Stesso indirizzo di «{name}». Entrambi i canali stampano uno dopo l\'altro sullo stesso dispositivo.',
      company:           'Azienda',
      range:             'Da / A',
      rangeFrom:         'Da',
      rangeTo:           'A',
      tableRangesHint:   'Se sono impostati degli intervalli, questo canale riceve solo le comande e le ricevute il cui numero di tavolo rientra in uno degli intervalli. Vale anche per Kitchen TV, schermata di ritiro e Fastline. I documenti senza numero di tavolo – tra cui le chiusure giornaliere e i conteggi del personale – arrivano sempre a questo canale. Se non è impostato alcun intervallo, riceve tutto.',
      qrCode:            'Stampa QR code',
      qrCodeHint:        'Aggiunge un QR code sullo scontrino. È anche il presupposto perché gli ordini compaiano sulla schermata di ritiro di questa stampante.',
      qrCodeOffByKitchenTv: 'Il QR code sullo scontrino resta disattivato finché la vista Kitchen TV è attivata: i due non sono mai attivi contemporaneamente sulla stessa stampante. Attivandolo qui si disattiva la vista Kitchen TV.',
      qrCodeOffByU220: 'Il TM-U220 non stampa codici QR. Su questo modello l\'interruttore è bloccato e non ha effetto.',
      showName:          'Mostra nome stampante',
      colorWorking:      'Colore in lavorazione',
      colorReady:        'Colore pronto per il ritiro',
      displayDuration:   'Durata visualizzazione',
      preview:           'Anteprima',
      kitchenTvEnabled:  'Kitchen TV',
      kitchenTvEnabledHint: 'Mostra gli ordini di questa stampante anche su uno schermo Kitchen TV. La stampante resta una stampante a tutti gli effetti e continua a stampare. All\'attivazione il QR code sullo scontrino viene disattivato.',
      autoStartTimer:    'Avvia timer automaticamente',
      autoStartTimerHint:'Avvia il timer automaticamente alla ricezione di un ordine',
      disablePrintingWhenKitchenTv:     'Non stampare le comande',
      disablePrintingWhenKitchenTvHint: 'Le comande di questo canale non vengono più stampate, ma solo mostrate sul Kitchen TV. Sono considerate consegnate subito e compaiono nell\'elenco dei lavori con la nota «consegnato senza stampa». Gli scontrini di cassa continuano a essere stampati. Su un canale di solo schermo l\'impostazione non ha effetto, perché lì non si stampa mai.',
      fastline:          'Fastline',
      rangeRemove:       'Rimuovi intervallo {n}',
      abholscreenUrl:    'URL schermo di ritiro',
      kitchenTvUrl:      'URL Kitchen TV',
      kitchenTvUrlLight: 'URL Kitchen TV Light',
      fastlineUrl:       'URL Fastline',
    },
    // Der aktive Bildschirm-Modus, angezeigt statt eingestellt
    // (REQ-SC-106 (2), T-M25.5). Die drei Modusnamen sind Produktnamen und
    // stehen in allen sechs Sprachen gleich; die Feldwerte bleiben
    // technisch-englisch (REQ-OV-002, REQ-DM-068 (1)).
    screenMode: {
      label:    'Modalità attiva',
      hint:     'Mostra quale schermo gestisce attualmente questo canale. La modalità viene assunta sullo schermo stesso, non qui: chi apre uno dei tre indirizzi conferma lì il cambio e disattiva così la modalità precedente.',
      mode_normal:   'Kitchen TV normal',
      mode_light:    'Kitchen TV Light',
      mode_fastline: 'Fastline',
      mode_none:     'nessuna modalità attiva',
    },
    kitchenTvInactive: 'Kitchen TV è disabilitato. Abilitalo sopra per modificare le impostazioni.',
    kitchenTvAlwaysOn: 'Questo canale è un canale schermo: la vista Kitchen TV è sempre attiva e non può essere disattivata.',
    // Druckerzustand: grob (status.*) plus feine Kennungen (REQ-PS-020a/021).
    // Werte bleiben technisch-englisch in Firestore, hier nur die Anzeige.
    status: {
      title:       'Stato attuale',
      noDetail:    'Nessuna anomalia',
      updatedAt:     'Stato invariato da',
      updatedAtHint: 'Il momento dell\'ultima MODIFICA dello stato, non quello dell\'ultima segnalazione. Il server di stampa scrive questo valore solo quando lo stato cambia; una stampante costantemente senza errori mostra quindi qui un orario vecchio.',
      never:         'Nessuno stato segnalato',
      stale: {
        withAge:    'Obsoleto — ultima segnalazione {age} fa',
        unknownAge: 'Obsoleto — età sconosciuta',
        age: {
          lessThanMinute: 'meno di un minuto',
          minute:  'un minuto',
          minutes: '{n} minuti',
          hour:    'un\'ora',
          hours:   '{n} ore',
          day:     'un giorno',
          days:    '{n} giorni',
        },
        reason: {
          noPrintserver: 'A questa stampante non è assegnato alcun server di stampa. Lo stato viene scritto esclusivamente dal server di stampa: senza di esso l\'ultimo valore scritto rimane invariato a tempo indeterminato.',
          noPing:        'Il server di stampa competente non ha ancora scritto alcun segnale di vita. Non è quindi possibile dire quanto sia vecchio lo stato mostrato.',
          serverOffline: 'Il server di stampa competente è offline. Non può più segnalare lo stato di questa stampante; viene mostrato l\'ultimo valore scritto.',
          pingTooOld:    'L\'ultimo segnale di vita del server di stampa competente supera il limite di 90 secondi (tre volte l\'intervallo di 30 secondi). Lo stato mostrato è l\'ultimo scritto e potrebbe non essere più valido.',
        },
      },
      sourceLabel: 'Origine',
      levelLabel:  'Livello di dettaglio',
      levelHint:   'Quanto in dettaglio questo modello di stampante può informare.',
      detail: {
        offline:     'Non raggiungibile',
        coverOpen:   'Coperchio aperto',
        paperOut:    'Carta esaurita',
        cutterError: 'Errore della taglierina',
        error:       'Errore stampante',
        notResponding: 'Non risponde',
        paperLow:    'Carta quasi esaurita',
      },
      source: {
        asb:        'Segnalato dalla stampante',
        poll:       'Interrogazione attiva',
        jobResult:  'Dedotto dal risultato di stampa',
        connection: 'Connessione interrotta',
      },
      level: {
        full:  'Completo',
        basic: 'Limitato',
        none:  'Nessun riscontro di stato',
      },
    },
    archived:     'Archiviata',
    archivedHint: 'Le stampanti archiviate non accettano più lavori.',
    incomplete:     'Incompleta',
    // Corretto il 2026-09-07 (T-M33.3, REQ-DM-072 (h)): dal T-M8.3 i lavori
    // destinati a una stampante senza server di stampa vengono respinti con 400
    // — non vengono accettati e poi lasciati senza consegna.
    incompleteHint: 'Questa stampante non ha un server di stampa di destinazione. Accetta lavori solo dopo l\'assegnazione di un server di stampa; fino ad allora i lavori inviati vengono respinti.',
    filter: {
      all:            'Tutte',
      unassigned:     'Senza server di stampa ({count})',
      noneUnassigned: 'A ogni stampante è assegnato un server di stampa.',
    },
    quickAssign: {
      label:       'Assegna server di stampa',
      placeholder: 'Assegna server di stampa …',
      saving:      'Assegnazione in corso …',
      failed:      'Non è stato possibile salvare l\'assegnazione. Riprova.',
      noServers:   'Per questa azienda non è registrato alcun server di stampa.',
    },
    unassignedNotice: {
      title: 'Nessun server di stampa assegnato',
      body:  'Questa stampante è stata creata tramite l\'interfaccia e accetta lavori solo dopo l\'assegnazione di un server di stampa. Seleziona un server di stampa qui sotto e salva.',
    },
    validation: {
      nameRequired:         'Inserisci una denominazione.',
      numberRequired:       'Inserisci l\'ID stampante dal portale Payfix.',
      // NUOVO 2026-09-18 (T-M41.8, REQ-DM-036 Praez. 4 (ix)).
      payfixPrinterIdInvalid: 'Questo ID stampante non può essere salvato. Non sono ammessi la barra obliqua, i valori «.» e «..», gli identificativi della forma «__…__» e più di 1500 byte. Inserisci l\'identificativo registrato per questa stampante nel portale Payfix.',
      payfixPrinterIdTaken: 'L\'ID stampante {id} è già assegnato alla stampante «{name}» dell\'azienda «{company}». Ogni ID può esistere una sola volta — altrimenti lo scontrino finisce sul canale sbagliato. Inserisci l\'ID registrato per questa stampante nel portale Payfix.',
      payfixPrinterIdTakenOtherCompany: 'L\'ID stampante {id} è già assegnato alla stampante «{name}» dell\'azienda «{company}» — quindi al di fuori dell\'azienda selezionata qui, e quella stampante non è visibile per te. Ogni ID può esistere una sola volta — altrimenti lo scontrino finisce sul canale sbagliato. Contatta i responsabili di «{company}» oppure inserisci l\'ID registrato per questa stampante nel portale Payfix.',
      payfixPrinterIdTakenOtherCompanyUnnamed: 'L\'ID stampante {id} è già assegnato in un\'altra azienda. Quale azienda sia non viene mostrato qui — si trova al di fuori del tuo accesso. Ogni ID può esistere una sola volta — altrimenti lo scontrino finisce sul canale sbagliato. Contatta il supporto Payfix oppure inserisci l\'ID registrato per questa stampante nel portale Payfix.',
      payfixPrinterIdTakenOrphaned: 'L\'ID stampante {id} è già assegnato alla stampante «{name}», e quella stampante non è associata a nessuna azienda leggibile — un ID orfano. Resta quindi occupato in tutto il sistema benché non sia possibile trovare alcuna azienda. Inserisci un altro ID registrato nel portale Payfix e segnala l\'ID orfano all\'esercizio.',
      payfixPrinterIdTakenOrphanedUnnamed: 'L\'ID stampante {id} è già occupato, e la stampante che lo occupa non è associata a nessuna azienda leggibile — un ID orfano. Resta quindi occupato in tutto il sistema benché non sia possibile trovare alcuna azienda. Inserisci un altro ID registrato nel portale Payfix e segnala l\'ID orfano all\'esercizio.',
      payfixPrinterIdCheckFailed: 'Non è stato possibile verificare l\'ID stampante — il servizio di verifica non è al momento raggiungibile. Non è stato salvato nulla. Riprova tra un momento.',
      printserverRequired:  'Seleziona un server di stampa. Senza server di destinazione il lavoro non viene consegnato.',
      modelTypeRequired:    'Seleziona un tipo di modello (Standard, U220 o Sunmi).',
      ipAddressRequired:    'Inserisci l\'indirizzo IP o il nome host della stampante. Senza indirizzo il server di stampa non può né comandarla né interrogarne lo stato.',
      printserverForbidden: 'Un canale schermo non può avere un server di stampa.',
    },
    warnings: {
      abholscreenNeedsQrCode:       'La schermata di ritiro resta vuota su questa stampante: senza la stampa del QR sullo scontrino non vi compare nessun ordine. Il QR stampato sullo scontrino è la prova di ritiro dell\'ospite. Attivare la stampa del QR in un secondo momento vale solo per i nuovi ordini in arrivo — gli ordini già creati non compaiono retroattivamente.',
      abholscreenNeedsQrCodeAction: 'Attivare la stampa del QR sullo scontrino',
      abholscreenNeedsKitchenTvAction: 'Attivare la vista Kitchen TV',
      abholscreenNeedsQrCodeSave:   'Schermata di ritiro attiva, stampa del QR sullo scontrino disattivata: questa schermata di ritiro resta vuota. Fare di nuovo clic su Salva per salvare comunque l\'impostazione.',
    },
    notices: {
      displayDurationDisabled:     'Senza effetto: il completamento automatico è disattivato',
      displayDurationDisabledHint: 'Finché il completamento automatico è disattivato, alla scadenza di questa durata non succede nulla. Il valore resta salvato e torna ad avere effetto non appena il completamento automatico viene riattivato.',
    },
  },

  printserver: {
    title:              'Server di stampa',
    subtitle:           'Server di stampa collegati di questa azienda',
    subtitleAllCompanies: 'Server di stampa collegati di tutte le aziende',
    subtitleOwnCompanies: 'Server di stampa collegati delle tue aziende',
    add:                'Aggiungi server di stampa',
    empty:              'Nessun server di stampa creato',
    emptyHint:          'Aggiungi il primo server di stampa.',
    name:               'Nome',
    uuid:               'UUID',
    uuidCopy:           'Copia UUID',
    uuidLabel:          'UUID (generato automaticamente)',
    uuidHint:           'Una designazione per le persone, non un valore di configurazione: il daemon non legge l\'UUID. Per la configurazione vale l\'ID del documento.',
    documentId:         'ID documento',
    documentIdHint:     'Il daemon legge questo identificativo come PRINTSERVER_ID dal suo file .env. Viene assegnato alla creazione e non può essere modificato.',
    documentIdPending:  'L\'identificativo viene creato con il salvataggio.',
    ipAddress:          'Indirizzo IP',
    anydeskId:          'ID AnyDesk',
    anydeskIdMissing:   'Il server di stampa comunica l\'ID AnyDesk all\'avvio. Se manca, sul dispositivo è ancora in esecuzione un software più vecchio che non lo comunica, oppure AnyDesk non vi è installato o l\'ID non è leggibile.',
    company:            'Azienda',
    status:             'Stato',
    connectedSince:     'Connesso dal',
    lastContact:        'Ultimo contatto',
    connectedMins:      '{n} min. connesso',
    connectedHrs:       '{h} h {m} min. connesso',
    lessThan1Min:       '< 1 min.',
    lastContactSec:     '{n} sec. fa',
    lastContactMin:     '{n} min. fa',
    lastContactHr:      '{n} h fa',
    nodeVersion:        'Versione Node.js',
    appVersion:         'Versione app',
    printerCount:       'Stampanti collegate',
    printerCountValue:  '{n}',
    printerCountAtLeast:'almeno {n}',
    printerCountAtLeastHint: 'L\'elenco delle stampanti è caricato solo pagina per pagina ({count} per pagina): il numero è un limite inferiore. Altre stampanti possono appartenere a questo server di stampa; carica altre.',
    printerCountUnknownHint: 'L\'elenco delle stampanti non è ancora disponibile. Il numero compare non appena viene caricato.',
    runtimeFieldPending:'Il server di stampa comunica questo campo al cambio di stato (avvio o arresto). I dispositivi con software più vecchio non lo comunicano ancora: il valore compare dopo il prossimo riavvio.',
    updateAvailable:    'Aggiornamento disponibile: v{v}',
    restartControl:     'Controllo riavvio',
    restartManual:      'Riavvio manuale',
    restartHint:        'Invia un comando di riavvio all\'applicazione Node.js sul Raspberry Pi.',
    restartAfter:       'Riavvia dopo (minuti)',
    restartNow:         'Riavvia ora',
    restarting:         'Riavvio …',
    // ⚠ `restartSent` ist am 2026-09-18 mit T-M41.9 in allen sechs Sprachen
    // ENTFALLEN; die Begründung steht am selben Ort in `de.ts`.
    // NUOVO 2026-09-18 (T-M41.9): la conferma dal documento in tempo reale
    // sostituisce il messaggio di successo dopo il clic — due orari, nessun verdetto.
    restartRequested:        'Riavvio richiesto il {t}',
    restartNotAcknowledged:  'Nessuna conferma dal dispositivo finora.',
    restartExecuted:         'Eseguito dal dispositivo il {t}',
    restartReconnected:      'Riconnesso dal {t}',
    autoRestartDelayHint: 'La modifica ha effetto dal prossimo avvio del launcher sul dispositivo — come l\'orario di riavvio. 0 = nessun intervallo.',
    autoRestart:        'Riavvio automatico',
    autoRestartHint:    'L\'app viene riavviata automaticamente dopo questo intervallo. 0 = disabilitato.',
    autoRestartDisabled:'Il riavvio automatico è disabilitato.',
    autoRestartEnabled: 'L\'app viene riavviata ogni {n} minuti.',
    connectionInfo:     'Informazioni di connessione',
    connectionHint:     'Il Raspberry Pi aggiorna IP, versione e stato automaticamente tramite il heartbeat Firestore.',
    deleteTitle:        'Eliminare il server di stampa?',
    deleteConfirm:      'Vuoi davvero eliminare {name}?',
    cannotUndoFull:     'Vuoi davvero eliminare «{name}»? Questa azione non può essere annullata.',
    new:                'Nuovo server di stampa',
    stammdaten:         'Dati di base',
    assignCompany:      'Associa azienda',
    noCompany:          '— Nessuna azienda associata —',
    companyHint:        'Il server di stampa appare solo per gli utenti di questa azienda.',
    companyPreset:      'Preimpostato',
    companySearch:      'Cerca azienda …',
    companySelect:      'Seleziona azienda',
    companyNoMatch:     'Nessuna azienda trovata.',
    cascadeTitle:       'Le stampanti perdono il loro server di stampa',
    cascadeText:        'Stampanti assegnate a questo server di stampa ({count}): {names}. Perdono l\'assegnazione e non accettano più lavori finché non viene loro assegnato un server di stampa.',
    cascadeConfirm:     'Rimuovi l\'assegnazione e continua',
    companyRequired:    'Associare un\'azienda. Se il server di stampa non deve più appartenere ad alcuna azienda, eliminarlo.',
    infoCard:           'Info',
    piSetup:            'Configurazione Raspberry Pi',
    piSetupHint:        'Inserisci questo identificativo nel file .env del daemon Raspberry Pi:',
    piSetupPending:     'Salva prima il server di stampa. Poi qui comparirà l\'identificativo da inserire nel file .env del daemon Raspberry Pi.',
    settingsTitle:      'Tutti i server di stampa configurati – clicca per aprire',
    settingsNoCompany:  '— Nessuna azienda —',
    settingsAddFirst:   'Crea il primo server di stampa',
    location:           'Sede',
    noLocation:         '— Nessuna sede associata —',
    locationHint:       'Assegna il server di stampa a una sede.',
  },

  locations: {
    title:            'Sedi',
    subtitle:         'Tutte le sedi di questa azienda',
    add:              'Aggiungi sede',
    empty:            'Nessuna sede ancora creata',
    emptyHint:        'Aggiungi la prima sede di questa azienda.',
    name:             'Nome della sede',
    namePlaceholder:  'ad es. Sede principale Zurigo',
    new:              'Nuova sede',
    edit:             'Modifica',
    autoUpdate:       'Aggiornamento automatico',
    autoUpdateOn:     'Attivo',
    paused:           'In pausa',
    updateSection:    'Aggiornamento automatico',
    updatePaused:     'Sospendi aggiornamento',
    updatePausedHint: 'Sospende l\'aggiornamento automatico dei server di stampa di questa sede.',
    updateChannel:    'Canale di aggiornamento',
    channelStable:    'Stabile',
    channelBeta:      'Beta',
    pinnedVersion:    'Versione fissata',
    pinnedVersionHint:'Lasciare vuoto per la versione più recente nel canale scelto.',
    latest:           'Più recente',
    deleteTitle:      'Eliminare la sede?',
    deleteConfirm:    'Vuoi davvero eliminare {name}?',
  },

  jobs: {
    title:          'Lavori di stampa',
    subtitle:       'Tutti i lavori di stampa di questa azienda',
    new:            'Nuovo lavoro',
    empty:          'Nessun lavoro di stampa disponibile.',
    emptyFiltered:     'Nessuno dei lavori caricati corrisponde ai filtri impostati.',
    emptyFilteredHint: 'Altri lavori possono essere caricati qui sotto.',
    id:             'ID lavoro',
    printer:        'Stampante',
    register:       'Cassa',
    status:         'Stato',
    createdAt:      'Creato il',
    updatedAt:      'Ultimo aggiornamento',
    payload:        'Payload',
    create:         'Crea lavoro di stampa',
    send:           'Invia lavoro di stampa',
    sending:        'Creazione in corso …',
    selectRegister: 'Seleziona cassa …',
    payloadLabel:   'JSON Payload (formato Payfix)',
    loadExample:    'Carica esempio',
    invalidJson:    'JSON non valido. Verificare.',
    created:        'Lavoro di stampa creato',
    sourcePayfix:   'Payfix',
    sourceDashboard:'Dashboard',
    source:          'Origine',
    type:            'Tipo',
    typePrintjobs:   'Lavori di stampa',
    typeReceipts:    'Ricevute',
    statusAll:       'Tutti',
    allPrinters:     'Tutte le stampanti',
    allPrintservers: 'Tutti i server di stampa',
    cashier:         'Collaboratore',
    positions:       'Voci',
    total:           'Totale',
    received:        'Ricevuto',
    printed:         'Stampato',
    paymentMethod:   'Metodo di pagamento',
    items:           'Voci',
    posName:         'Articolo',
    posQty:          'Quantità',
    posUnit:         'Prezzo unitario',
    posTotal:        'Totale',
    subtotal:        'Subtotale',
    tax:             'IVA',
    noItems:         'Nessuna voce disponibile.',
    resend:          'Invia di nuovo',
    deleteTitle:     'Eliminare il lavoro di stampa?',
    deleteConfirm:   'Vuoi davvero eliminare il lavoro {id}?',
    loadMore:          'Carica altri lavori',
    loadingMore:       'Caricamento …',
    loadedCount:       '{count} lavori caricati',
    endOfList:         'Fine dell’elenco – tutti i lavori sono caricati.',
    loadMoreError:     'Caricamento non riuscito.',
    liveFirstPageOnly: 'Solo la prima pagina si aggiorna in tempo reale.',
    device:          'Dispositivo',
    deleteError:     'Eliminazione non riuscita.',
    resendError:     'Invio non riuscito. Il lavoro non è stato creato.',
    resendNoPrintserver: 'Invio non possibile: al canale non è assegnato alcun server di stampa (i canali a schermo non possono essere stampati).',
    deliveryStatus:  'Stato di consegna',
    printerName: {
      idHint:         'Identificativo stampante: {id}',
      unresolved:     'Nome non risolvibile',
      unresolvedHint: 'Nell\'elenco stampanti caricato non esiste alcun canale con questo identificativo – probabilmente è stato eliminato. Identificativo: {id}',
      notLoaded:      'Nome non caricato',
      notLoadedHint:  'L\'elenco stampanti è caricato solo pagina per pagina, quindi il nome di questo canale non è ancora presente. Questo non dice se il canale esista ancora: carica altre stampanti. Identificativo: {id}',
    },
    workStatus: {
      label:              'Stato di lavorazione',
      columnHint:         'Seconda dimensione di stato, indipendente: solo gli ordini (comande) hanno uno stato di lavorazione. Gli scontrini non ne hanno, perciò il loro campo resta vuoto. Viene mostrato solo sui canali con la vista Kitchen TV attivata; in tutte le altre righe il campo resta anch\'esso vuoto — nel dettaglio del lavoro il valore vi rimane visibile non appena si discosta da «Aperto».',
      open:               'Aperto',
      inPreparation:      'In lavorazione',
      ready:              'Pronto per il ritiro',
      done:               'Concluso',
      unknown:            'Sconosciuto',
      unknownHint:        'Questo valore non fa parte del vocabolario previsto.',
      notPrintedDoneHint: 'Nessuna contraddizione: consegna e lavorazione sono due indicazioni distinte. Il lavoro non ha mai raggiunto la destinazione, ma è stato chiuso a livello operativo (automaticamente dopo quattro ore).',
      readOnly:           'Sola visualizzazione – lo stato di lavorazione non viene modificato qui.',
    },
    // Omissione registrata sullo scontrino (REQ-PR-037, integrazione
    // REQ-DM-030, T-M11.12).
    omitted: {
      badge:       'Scontrino incompleto',
      badgeHint:   'Il lavoro è stato consegnato, ma il modello di stampante non ha potuto eseguire alcuni comandi dello scontrino. Il dettaglio espanso indica che cosa è stato omesso.',
      title:       'Comandi non eseguiti',
      position:    'Posizione',
      opcode:      'Opcode',
      opcodeNone:  'nessun comando specifico',
      reasonLabel: 'Motivo',
      unknownHint: 'Questo valore non fa parte del vocabolario previsto.',
      reason: {
        unsupportedByModel: 'Non supportato dal modello di stampante',
        emptyPayload:       'Nessun dato utile',
        invalidParameter:   'Parametro non valido',
        unflushedBuffer:    'Buffer di riga non emesso',
        unknownOpcode:      'Comando di stampa sconosciuto',
        logoUnreadable:     'Logo non stampabile',
        unknown:            'Sconosciuto',
      },
      detail: {
        cut:      'Taglio completo',
        textline: 'Buffer di riga',
        unknown:  'Sconosciuto',
      },
    },
    deliveredWithoutPrint: {
      badge:     'Consegnato senza stampa',
      badgeHint: 'Questo lavoro non è stato stampato intenzionalmente: il canale mostra le comande solo sullo schermo. Vale come consegnato al momento della ricezione e quindi non riporta alcun orario di stampa.',
      title:     'Consegnato senza stampa',
      timeLabel: 'Consegnato (senza stampa)',
    },
    deliveryConfirmation: {
      badge:     'Consegnato senza conferma della stampante',
      badgeHint: 'Questo modello di stampante non conferma la stampa; è stata misurata solo la trasmissione.',
    },
    // Anteprima del contenuto dello scontrino (REQ-OPS-060, T-M29.3) — sola
    // lettura ed espressamente NON un'anteprima di stampa. Nessun comando viene
    // omesso in silenzio (REQ-PR-020).
    belegVorschau: {
      title:               'Contenuto dello scontrino (anteprima)',
      abweichungsHinweis:  'Non è un\'anteprima di stampa: lo scontrino stampato può differire. Larghezza delle righe, dimensione del testo e immagini nascono solo nella stampante.',
      u220Hinweis:         'Questo scontrino usa il linguaggio di comandi della TM-U220. Per esso non esiste un\'anteprima — gli stessi numeri di comando hanno lì un altro significato, una visualizzazione sarebbe indovinata anziché letta.',
      leerHinweis:         'Questo scontrino non contiene comandi di stampa.',
      platzhalter: {
        align:           'Allineamento',
        textSize:        'Dimensione del testo',
        cut:             'Taglio',
        qr:              'Codice QR',
        image:           'Immagine',
        textEmpty:       'Comando di testo senza contenuto',
        unknown:         'Comando sconosciuto {opcode} alla posizione {position}',
        unknownNoOpcode: 'Comando senza numero alla posizione {position}',
      },
    },
  },

  settings: {
    title: 'Impostazioni',

    company: {
      title:            'Aziende',
      subtitle:         'Tutte le aziende registrate',
      eyebrow:          'Impostazioni · Azienda',
      add:              'Aggiungi azienda',
      empty:            'Nessuna azienda creata.',
      name:             'Nome azienda',
      nameLabel:        'Nome azienda *',
      email:            'E-mail',
      phone:            'Telefono',
      address:          'Indirizzo',
      city:             'Città',
      zip:              'CAP',
      country:          'Paese',
      logo:             'Logo',
      description:      'Descrizione',
      descriptionHint:  'Note interne …',
      companyData:      'Dati azienda',
      bonSettings:      'Impostazioni scontrino',
      bonLogo:          'Logo scontrino',
      bonLogoHint:      'Appare in cima alla ricevuta cliente e alla ricevuta di storno, sul conto intermedio secondo l\'interruttore qui sotto, non sulle chiusure e non sulle stampanti TM-U220. PNG, JPG o SVG, max. 2 MB; viene ridotto alla larghezza di stampa e stampato in bianco e nero.',
      bonLogoDrop:      'Trascina o seleziona il logo qui',
      // T-M51.4 (REQ-DM-010a Praez. 1 (2)/(4)): Meldungen der Logo-Erfassung,
      // die Beschriftung der Druckvorschau und der Hinweis unter Schlusstext
      // und QR-Code-URL.
      bonLogoFileTooLarge:   'Il file supera i 2 MB.',
      bonLogoResultTooLarge: 'Anche ridotto, il logo è troppo grande per essere salvato. Scegli un file più semplice.',
      bonLogoNotImage:       'Il file non può essere letto come immagine.',
      bonLogoPrintPreview:   'Anteprima di stampa (bianco e nero)',
      bonFooterQrHint:       'Compaiono alla fine della ricevuta cliente, sul conto intermedio secondo gli interruttori qui sotto, non sulle ricevute di storno e sulle chiusure, e non sulle stampanti TM-U220.',
      // T-M54.5 (REQ-DM-010a Praez. 2 (4)): Kartenueberschrift und die drei
      // Schalter der Zwischenrechnung mit ihrem Hinweis.
      receiptSettings:       'Impostazioni ricevute',
      interimReceiptLogo:    'Stampa logo sul conto intermedio',
      interimReceiptFooter:  'Stampa testo finale sul conto intermedio',
      interimReceiptQr:      'Stampa QR code sul conto intermedio',
      interimReceiptHint:    'Vale per il conto intermedio della cassa, sulle stampanti Epson e Sunmi, non sulle stampanti TM-U220. Ciò che non è inserito sopra non viene stampato nemmeno sul conto intermedio.',
      bonFooter:        'Piè di pagina scontrino',
      qrUrl:            'URL QR code',
      usersSection:     'Utenti',
      usersSubtitle:    'Utenti di questa azienda e i loro diritti di modifica',
      addUser:          'Aggiungi utente',
      noUsers:          'Nessun utente assegnato',
      userCol:          'Utente',
      emailCol:         'E-mail',
      removeUser:       'Rimuovere l\'utente?',
      removeUserConfirm:'Vuoi davvero rimuovere questo utente dall\'azienda?',
      existingUser:     'Utente esistente',
      inviteByEmail:    'Invita tramite e-mail',
      userSearch:       'Cerca utente …',
      noUsersFound:     'Nessun utente trovato',
      inviteSent:       'Invito inviato a {email}!',
      inviteEmailHint:  'L\'utente riceve una e-mail con un link per impostare la sua password.',
      systemRole:       'Ruolo di sistema',
      roleUser:         'Utente',
      roleAdmin:        'Amministratore',
      deleteTitle:      'Eliminare l\'azienda?',
      deleteConfirm:    'Vuoi davvero eliminare {name}?',
      cannotUndoFull:   'Vuoi davvero eliminare «{name}»? Questa azione non può essere annullata.',
      payfixId:         'ID cliente Payfix',
      payfixIdHint:     'Assegnato da Payfix e non modificabile.',
      receiptFooter:    'Testo finale della ricevuta',
      footerPlaceholder:'Grazie per il tuo acquisto!',
      alarmCenter:      'Centrale allarmi',
      alarmSectionSub:  'Notifiche automatiche in caso di problemi',
      emailAlarm:       'Allarme e-mail',
      emailAlarmHint:   'Notifiche via e-mail',
      alarmWhen:        'Quando allertare?',
      triggerQueueOffline:      'Coda offline',
      triggerQueueOfflineDesc:  'Notifica quando la coda del server di stampa va offline',
      triggerNotPrinted:        'Lavoro di stampa non stampato (10 min)',
      triggerNotPrintedDesc:    'Notifica quando uno scontrino non è ancora stato stampato dopo 10 minuti',
      triggerPrinterOffline:    'Guasto stampante',
      // `alarmOnPrinterOffline` traegt ALLE Drucker-Stufen, nicht nur `offline`
      // (T-M42.10); bis zum 2026-09-26 lautete der Text „Drucker Offline“.
      triggerPrinterOfflineDesc:'Notifica per ogni livello di allarme attivato sulla stampante (offline, errore, carta quasi esaurita, coperchio aperto, carta esaurita)',
      // T-M42.10 Teil (b): Alarmierung nicht eingerichtet (utils/alarmEinrichtung.ts).
      alarmNotSetUp:             'Allarmi non configurati',
      alarmNotSetUpNoType:       'Nessun tipo di allarme è attivato. Per questa azienda al momento non viene inviato alcun allarme.',
      alarmNotSetUpNoRecipients: 'Nessun destinatario indicato: attivare l\'allarme via e-mail e inserire almeno un indirizzo. Fino ad allora per questa azienda non viene inviato alcun allarme.',
      alarmNotSetUpSavedState:   'Fa fede lo stato salvato.',
    },

    users: {
      title:           'Utenti',
      subtitle:        'Tutti gli utenti di questa azienda',
      eyebrow:         'Impostazioni · Utenti',
      add:             'Invita utente',
      empty:           'Nessun utente disponibile.',
      searchEmpty:     'Nessun utente trovato per «{search}».',
      name:            'Nome',
      email:           'E-mail',
      role:            'Ruolo',
      status:          'Stato',
      lastLogin:       'Ultimo accesso',
      data:            'Dati utente',
      emailHint:       'L\'e-mail non può essere modificata dopo la creazione.',
      inviteHint:      'L\'utente riceve una e-mail di invito per impostare la sua password.',
      roleAccess:      'Ruolo & Accesso',
      internalNote:    'Nota interna',
      internalNotePH:  'Responsabilità, reparto …',
      noAccount:       'Nessun account di accesso',
      noAccountHint:   'Questo utente è stato creato senza Firebase Auth e non può accedere. Invia una e-mail di invito per correggere questo.',
      inviteSent:      'Invito inviato!',
      inviteSentHint:  'Una e-mail è stata inviata a {email}. L\'utente può così impostare la sua password.',
      deleteTitle:     'Eliminare l\'utente?',
      deleteConfirm:   'Vuoi davvero eliminare «{name}»? L\'utente perderà immediatamente l\'accesso.',
      invite:          'Invia invito',
      invited:         'Invitato',
      companies:       'Aziende',
      companiesHint:   'L\'utente vede e gestisce i dati di queste aziende.',
      // Per il ruolo `admin` questa nota sostituisce l'elenco di caselle
      // (REQ-SEC-030 prec. 1 (c), REQ-SEC-027 (a) — T-M38.4).
      companiesAdminHint: 'Gli amministratori hanno accesso a tutte le aziende; non è necessaria alcuna assegnazione.',
      companiesNone:   'Non ancora assegnato a nessuna azienda.',
      companySearch:   'Cerca azienda …',
      companyNoMatch:  'Nessuna azienda trovata.',
      companyLimit:    'Un utente può avere al massimo {max} aziende. Rimuovi prima un\'azienda.',
      companyRequired: 'Seleziona almeno un\'azienda per l\'invito.',
      invitations:     'Inviti aperti',
      openInvitation:  'Invito aperto',
      validUntil:      'Valido fino al {date}',
      expiredOn:       'Scaduto il {date}',
      reinvite:        'Invita di nuovo',
      inviteFailed:    'Non è stato possibile inviare l\'invito.',
    },

    smtp: {
      title:            'E-mail SMTP',
      subtitle:         'Impostazioni per l\'invio di e-mail',
      infoText:         'Queste impostazioni SMTP sono per le e-mail personalizzate. Firebase Auth invia le e-mail di sistema indipendentemente.',
      serverConnection: 'Connessione al server',
      authentication:   'Autenticazione',
      sender:           'Mittente',
      statusCard:       'Stato',
      encryption:       'Crittografia',
      lastSaved:        'Ultimo salvataggio',
      testSentTo:       'E-mail di prova inviata a {email}!',
      host:             'Host SMTP',
      port:             'Porta',
      user:             'Nome utente',
      password:         'Password',
      fromEmail:        'E-mail mittente',
      fromName:         'Nome mittente',
      secure:           'Usa SSL / TLS',
      test:             'Invia e-mail di prova',
      testSent:         'E-mail di prova inviata con successo!',
      save:             'Salva impostazioni SMTP',
      noEncryption:     'Nessuna crittografia (Porta 25)',
      starttls:         'STARTTLS (Porta 587)',
      tls:              'SSL/TLS (Porta 465)',
      activeLabel:      'SMTP attivo',
      activeNotice:     'Le e-mail di invito e le notifiche di sistema vengono inviate tramite questa configurazione SMTP.',
      activeFallback:   'Se SMTP non è configurato, viene utilizzato automaticamente Firebase Authentication come fallback.',
      secretBadge:      'Memorizzato come secret Firebase',
      secretHint:       'Questo segreto non è conservato nel database e non viene mai caricato nel browser. Viene impostato lato server nel progetto Firebase con il comando qui sotto. Inserisci il valore quando richiesto o passalo tramite pipe con printf %s, mai con echo: echo aggiunge un a capo, che viene ripreso invariato nel segreto.',
    },

    api: {
      eyebrow:          'Impostazioni · API',
      title:            'Token API',
      subtitle:         'Token di accesso per l\'API REST pubblica',
      tokensTitle:      'Token API',
      tokensSubtitle:   'Token per l\'accesso API esterno — di questa azienda e globali',
      generate:         'Genera token',
      noCompany:        'Selezionare prima un\'azienda.',
      empty:            'Nessun token API presente.',
      colScope:         'Ambito',
      scopeGlobal:      'Globale',
      scopeCompany:     'Azienda',
      scopeGlobalHint:  'Valido per tutte le aziende.',
      scopeCompanyHint: 'Valido solo per questa azienda.',
      globalLabel:      'Token globale',
      globalHint:       'Valido per tutte le aziende invece che solo per questa. Da usare solo per accessi interni e da denominare in modo che si riconosca chi lo utilizza.',
      revokeGlobalHint: 'Questo token è valido per tutte le aziende. Dopo la revoca tutte le aziende perdono immediatamente l\'accesso tramite esso.',
      colName:          'Nome',
      colPrefix:        'Prefisso',
      colStatus:        'Stato',
      colCreated:       'Creato',
      colExpires:       'Valido fino al',
      colLastUsed:      'Ultimo utilizzo',
      statusActive:     'Attivo',
      statusRevoked:    'Revocato',
      neverExpires:     'Illimitato',
      revoke:           'Revoca token',
      tokenCreated:     'Token generato – salvalo ora!',
      tokenOnceHint:    'Il token viene mostrato solo ora una volta. Copialo in un luogo sicuro.',
      connectionTitle:  'Connessione',
      authLabel:        'Autenticazione',
      contentTypeLabel: 'Content-Type',
      connectionNote:   'Trasmetti il token a ogni richiesta nell\'intestazione Authorization come Bearer token.',
      createTitle:      'Genera un nuovo token API',
      createBody:       'Assegna facoltativamente un nome e una data di scadenza.',
      nameLabel:        'Nome (facoltativo)',
      namePlaceholder:  'ad es. Integrazione Payfix',
      expiresLabel:     'Data di scadenza (facoltativa)',
      expiresHint:      'Lasciare vuoto per un token illimitato.',
      revokeTitle:      'Revocare il token?',
      revokeBody:       'Il token «{name}» verrà revocato in modo irreversibile. Tutte le integrazioni che lo utilizzano perderanno immediatamente l\'accesso.',
      revokeConfirm:    'Sì, revoca',
    },
  },

  companySelect: {
    title:    'Seleziona azienda',
    subtitle: 'Seleziona un\'azienda per continuare.',
    search:   'Cerca azienda …',
    empty:    'Nessuna azienda trovata.',
    continue: 'Continua',
    notFound: 'Nessuna azienda trovata per «{query}»',
    // ⚠ ENTFALLEN AM 2026-08-22 (T-M24.3, REQ-OPS-058 (2)) — die vier Saetze
    // der Nachlade-Leiste (`limitReached`, `loadMore`, `loadedCount`,
    // `endOfList`) sind in allen sechs Sprachen zurueckgenommen; der deutsche
    // Wortlaut steht in `de.ts`. Die Firmen-Auswahl laedt alle Firmen auf
    // einmal. Die gleichnamigen Saetze unter `printers.*` bleiben stehen.
  },

  location: {
    offline: 'Sede offline',
  },

  fastline: {
    cameraOpen:    'Apri fotocamera',
    orderNumber:   'Numero ordine',
    search:        'Cerca',
    scan:          'Scansiona',
    scanQr:        'Scansiona codice QR',
    // Il tastierino della digitazione manuale (REQ-SC-099, T-M23.3).
    keypadOpen:      'Inserire il codice',
    keypadTitle:     'Inserire il codice manualmente',
    keypadHint:      'Ripiego quando il codice QR non è leggibile. Scanner e fotocamera restano la via normale.',
    keypadSearch:    'Cerca ordine',
    keypadBackspace: 'Cancella ultimo carattere',
    // I due schermi di esito (REQ-SC-100, T-M23.4).
    pickedUpTitle:     'Ritirato',
    pickedUpDone:      'L\'ordine è concluso e rimosso dall\'elenco.',
    pickedUpAutoClose: 'Questa finestra si chiude da sola tra {seconds} secondi.',
    notFoundTitle:     'Ordine non trovato',
    notFoundText:      'Questo codice è sconosciuto.',
    notFoundRescan:    'Scansiona di nuovo',
    notFoundManual:    'Inserire il codice manualmente',
    scanHint:      'Posiziona il codice QR nel riquadro',
    // Esito della scansione spostato in `screen.*` con T-M12.21 (REQ-SC-082).

    // L'unica azione principale della finestra di ritiro (REQ-SC-098 (4)).
    pickUp:        'Ritirare',
    scannerReady:     'Scanner pronto',
    scannerReadyHint: 'Scansiona il codice QR sullo scontrino — l\'ordine si apre da solo.',
  },

  kitchen: {
    toCook:           'Da cucinare',
    tickets:          'Ticket',
    allDone:          'Tutto fatto',
    openItems:        'Articoli aperti',
    open:             'Aperto',
    inProgress:       'In lavorazione',
    start:            'Avvia',
    markReady:        'Pronto per il ritiro',
    done:             'Fatto',
    emptyOpen:        'Nessun ordine aperto',
    emptyInProgress:  'Nessun ordine in lavorazione',
    emptyReady:       'Nessun ordine pronto per il ritiro',
    emptyOrders:      'Nessun ordine',
    doneAll:          'Tutto pronto!',
    actionFailed:     'Non salvato. Tocca di nuovo.',
    actionStale:      'L’ordine è cambiato. La vista si aggiorna da sola.',
    actionExpired:    'La sessione di questo schermo è scaduta. Ricarica la pagina.',
    // Raggruppamento e avvio per portata (REQ-SC-068, T-M12.8). L’identificativo
    // della portata è una STRINGA ripresa alla lettera — `Portata 2`, anche `Portata Ürli`.
    gangLabel:        'Portata {gang}',
    startGang:        'Avvia portata',
    // Artikel-Countdown (REQ-SC-071): Aufschrift der Startschaltflaeche.
    timerStart:       '{minutes} min',
    // Modifiche successive (REQ-SC-072, T-M12.7): etichetta del pulsante
    // rosso quando la quantità risultante scende a zero o sotto.
    fullyCancelled:   'Completamente annullato',
    // Dialogo del risultato della scansione di ritiro (REQ-SC-073, T-M12.10).
    // Il MOTIVO ESPLICITO di REQ-SC-087 si trova da T-M12.54 sotto
    // `screen.scanNotReady`: è la stessa frase su tutte e tre le viste.
    tableNumber:      'Tavolo {number}',
    scanReceived:     'Ricezione',
    scanNoDetail:     'I dettagli di questo ordine non sono disponibili su questo schermo.',
    // Stato della scheda nella vista Fastline (REQ-SC-097 (2)) — solo
    // visualizzazione; lo stato di lavorazione in Firestore resta `open`.
    waitingForPickupScan: 'In attesa della scansione di ritiro',
  },

  screen: {
    keyPrompt:      'Inserisci la chiave di visualizzazione',
    keyPlaceholder: 'Chiave di visualizzazione',
    connect:        'Connetti',
    connecting:     'Connessione in corso …',
    invalidKey:     'Chiave di visualizzazione non valida.',
    notPrinted:     'Scontrino non ancora stampato',
    limitReached:   'Vengono mostrati solo gli ultimi {count} ordini.',
    // Vista disattivata (REQ-SC-079, T-M12.19).
    viewDisabledTitle:       'Questa vista è disattivata',
    viewDisabledKitchenTv:   'La Kitchen TV non è attivata per questo canale.',
    viewDisabledAbholscreen: 'La schermata di ritiro non è attivata per questo canale.',
    viewDisabledChannel:     'Canale: {name}',
    viewDisabledHelp:        'Potete attivare la vista per questo canale in «Stampanti» nella dashboard.',
    // Presa in carico del modo schermo (REQ-SC-104 (5), T-M25.3) — per canale
    // è attivo un solo modo; lo schermo appena aperto nomina quello attivo e
    // scrive solo dopo la conferma.
    modeNameNormal:   'Kitchen TV',
    modeNameLight:    'Kitchen TV Light',
    modeNameFastline: 'Fastline',
    takeoverTitle:    'È attivo un altro modo',
    takeoverWarning:  'Su questo canale è attualmente attivo «{active}». Se avviate «{own}» qui, «{active}» viene disattivato.',
    takeoverIdle:     'Questo schermo non ha ancora preso in carico «{own}».',
    takeoverConfirm:  'Avviare «{own}» qui',
    takeoverRunning:  'Presa in carico in corso …',
    takeoverHint:     'Finché non confermate non cambia nulla: l’altro schermo continua a funzionare.',
    // Esito della scansione di ritiro (REQ-SC-082, T-M12.21) — condiviso dai tre schermi.
    alreadyPickedUp:       'Già ritirato',
    alreadyPickedUpAt:     'Ritirato il {time}',
    alreadyPickedUpNoTime: 'Orario non registrato',
    scanFound:             'Ordine trovato',
    scanCompleted:         'Completato',
    scanNotFound:          'Nessun ordine corrispondente trovato',
    scanError:             'Errore di scansione',
    scanNotReady:          'La scansione è registrata. La chiusura avviene solo da «Pronto per il ritiro».',
    // Immissione e scansione sulla schermata di ritiro (REQ-SC-012, T-M12.23).
    pickupPrompt: 'Inserire o scansionare il numero d’ordine',
    pickupNumber: 'Numero d’ordine',
    pickupSubmit: 'Ritirare',
    // Chiusura collettiva (REQ-SC-083, T-M12.22). La richiesta di conferma deve
    // dire che cosa viene chiuso e quanti ordini — e che non si stampa nulla.
    completeAll:        'Chiudere tutti',
    completeAllTitle:   'Chiudere tutti gli ordini?',
    completeAllBody:    '{count} ordini in «In lavorazione» e «Pronto per il ritiro» vengono chiusi. Si tratta di una pulizia della schermata: non viene stampato nulla e non viene emesso alcuno scontrino.',
    completeAllChunks:  'Gli ordini sono più di {max}. Vengono chiusi in {calls} passaggi; se un passaggio si interrompe, gli ordini dei passaggi successivi restano aperti.',
    completeAllConfirm: 'Sì, chiudere {count}',
    completeAllDone:    '{count} ordini chiusi.',
    completeAllNoScan:  'Non ritirati con un codice QR: {count} ordini non riportano alcuna scansione di ritiro. Chiudere comunque?',
    // Etichetta di provenienza al canale Fast Line (REQ-SC-095). «OrderMood»
    // e un nome proprio e resta uguale in tutte le lingue.
    originOrderMood: 'OrderMood',
    originRegister:  'Cassa',
  },

  // ── Das Kennzeichen des Testsystems (T-M32.7, REQ-OPS-061) ────────────────
  // Der Streifen am oberen Rand der Verwaltungsoberflaeche. Uebersetzt wird
  // allein das WORT „Testsystem"; `{projektId}` ist ein technischer Name und
  // steht in jeder Sprache gleich (REQ-OV-002, REQ-OV-008).
  // Der Emulator-Wortlaut ist der Sonderfall des lokalen Entwicklungswegs: dort
  // lautet die Projekt-ID `printerque-prod`, weil sie beim Emulatorlauf nur die
  // Audience der ID-Token ist (REQ-OPS-064 (a)) — ohne den Zusatz stuende ein
  // Widerspruch auf dem Bildschirm.
  umgebung: {
    testBanner:         'SISTEMA DI TEST · {projektId}',
    testBannerEmulator: 'SISTEMA DI TEST · {projektId} · Emulatore',
  },
}
